import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getInventoryLocations } from '../../actions/inventory';
import { InventoryLocationType } from '../../pages/Inventory/InventoryController';
import Select from '../../common/Form/Select';
import { debounce } from '../../utils/common';
import { useFormContext } from 'react-hook-form';
import { CLEAR_INVENTORY_LOCATIONS_DROPDOWN_LIST_DATA } from '../../types/inventory';

export default function Warehouse({ name, label, onChange = () => { }, org_id, prefill = [], addNew = false, className = '', readOnly = false, org_check_required = true, required = false, filter = [], prefillObj = null }) {
    const dispatch = useDispatch();
    const methods = useFormContext();
    const inventoryLocationsDropdown = useSelector((state) => state.inventory.inventoryLocationsDropdown);
    const isInventoryDropdownLocationsLoading = useSelector((state) => state.loading.isInventoryDropdownLocationsLoading);

    const memoizedInventoryLocationsDropdown = useMemo(() => {
        const warehouseOptions = inventoryLocationsDropdown[InventoryLocationType.WAREHOUSE] || [];
        let list = addNew ? [{ label: 'Add New Warehouse', value: 'add-new-warehouse' }, ...warehouseOptions] : warehouseOptions;
        if (filter.length > 0) {
            list = list.filter((item) => !filter.includes(item.value))
        }
        return list;
    }, [inventoryLocationsDropdown, addNew, filter]);

    const getWarehouseList = useCallback(({ limit = 100, page = 1, query = '', org_id }) => {
        dispatch(getInventoryLocations({ limit, page, query, dropdown: true, type: InventoryLocationType.WAREHOUSE, payload: { org_id } }));
    }, [dispatch]);

    const debouncedWarehouseSearchSearch = useMemo(() => debounce(getWarehouseList), [getWarehouseList]);

    useEffect(() => {
        let payload = {
            limit: 100,
            page: 1,
        };
        if (org_check_required) payload.org_id = org_id;
        getWarehouseList(payload);
    }, [org_id, org_check_required, getWarehouseList]);

    useEffect(() => {
        return () => {
            dispatch({ type: CLEAR_INVENTORY_LOCATIONS_DROPDOWN_LIST_DATA, payload: InventoryLocationType.WAREHOUSE });
        }
    }, [dispatch]);

    useEffect(() => {
        if (prefillObj && !methods.getValues(name)) {
            methods.setValue(name, prefillObj);
        }
        if (prefill && prefill.length > 0 && memoizedInventoryLocationsDropdown && memoizedInventoryLocationsDropdown.length > 0) {
            const find = memoizedInventoryLocationsDropdown.find((option) => prefill.includes(option.id));
            if (find && !methods.getValues(name)) {
                methods.setValue(name, find);
            }
        }
    }, [prefillObj, prefill, memoizedInventoryLocationsDropdown, name, methods]);

    return (
        <Select
            className={className}
            label={label}
            name={name}
            options={memoizedInventoryLocationsDropdown}
            isLoading={isInventoryDropdownLocationsLoading}
            onInputChange={(event) => {
                if (event.length > 0) {
                    let p = { query: event };
                    if (org_check_required) p.org_id = org_id;
                    debouncedWarehouseSearchSearch(p)
                }
            }}
            onChange={(event) => {
                const value = event?.value;
                onChange(value)
            }}
            readOnly={readOnly}
            required={required}
        />
    )
}